import React, {useContext, useRef, useEffect, useState} from 'react';
import {MapContext} from './MapContext';
import {formatLatLng} from '../../common/helper';
import InfoPopup from '../dashboard/InfoPopup';
import {useSelector} from 'react-redux';
import {selectActiveUser} from '../dashboard/dashboardSlice';
import {currentUserInfo, currentUserLocation, locationByID, ORMLocations} from '../../app/models/ormSelectors';
import {selectPopupShow} from './mapSlice';
import RippleCard from '../devicesCards/RippleCard';
import TrackimoCard from '../devicesCards/TrackimoCard';
import Card from '../../UI/Card';
const RIPPLE_NAME = 'Ripple Button';
const TRACKIMO_NAME = 'Geozilla Tracker';


const Overlay = () => {
    const ormLocations = useSelector(ORMLocations);
    const userInfo = useSelector(currentUserInfo);
    const initialCoords = formatLatLng(useContext(MapContext).lat, useContext(MapContext).lng);
    const currentUserLatLng = useSelector(currentUserLocation)[0] || initialCoords;
    const lat = useContext(MapContext).lat;
    const lng = useContext(MapContext).lng;
    const map = useContext(MapContext).googleMap;
    const activeUser = useSelector(selectActiveUser);
    const geoByID = useSelector(locationByID);
    const [popup, setPopup] = useState(null);
    const position = formatLatLng(lat, lng);
    const card = useRef();
    const showPopup = useSelector(selectPopupShow);
    const isRippleDevice = userInfo.modelName === RIPPLE_NAME;
    const isTrackimo = userInfo.modelName === TRACKIMO_NAME;


    useEffect(() => {
        const infoWindow = new window.google.maps.InfoWindow({
            content: card.current,
            position,
        });

        setPopup(infoWindow);
    }, []);


    useEffect(() => {
        if (popup) {
            showPopup ? popup.open({map}) : popup.close();
        }
    }, [popup, showPopup]);

    useEffect(() => {
        if (popup && activeUser && currentUserLatLng) {

            if (geoByID(activeUser).location) {
                const selectedUserCoords = geoByID(activeUser).location;
                const latLng = formatLatLng(selectedUserCoords.latitude, selectedUserCoords.longitude);

                popup.setPosition(latLng);
            } else {
                popup.setPosition(initialCoords);
            }

        }
    }, [popup, ormLocations, activeUser, currentUserLatLng]);

    const cardContent = () => {
        if (isRippleDevice) {
            return <RippleCard/>
        }

        if (isTrackimo) {
            return <TrackimoCard/>
        }

        return <InfoPopup/>;
    }

    return (
        <div ref={card}>
            <Card>
                {cardContent()}
            </Card>
        </div>)
}


export default Overlay;